<template>
  <div class="apply">
    <div class="box-card">
      <div class="head">
        <span class="applyTitle">{{ $t("navbar.card") }}</span>
        <span class="applyEnd">
          {{ $t("active.tishi") }}{{ $t("active.date2") }}</span
        >
      </div>

      <div class="introduce">
        <span class="shuoMing">{{ $t("common.explain") }}</span>

        <div class="box">
          <div class="txt">
            {{ $t("card.explain") }}
            <span class="telNumber">{{ $t("card.explaincnnect") }}</span>
          </div>

          <!-- <div class="txt">
            {{ $t("card.explain1") }}
          </div> -->

          <div class="txt">
            {{ $t("card.explain3") }}
          </div>
        </div>
      </div>

      <!--  表单开始 -->
      <div class="instance">
        <div class="distribution">
          <p class="title">
            <span>{{ $t("card.allocation") }}</span>
          </p>

          <div class="tab">
            <table>
              <tbody>
                <!-- 第一行 -->
                <tr class="thead">
                  <th colspan="2" class="standard">
                    {{ $t("card.standard") }}
                  </th>
                  <th>{{ $t("card.showDard") }}</th>
                  <th class="notice">{{ $t("card.remark") }}</th>
                </tr>
                <!-- 第二行 -->
                <tr class="tbody two">
                  <th class="number">{{ $t("card.area", { area: 9 }) }}</th>
                  <th class="number">{{ $t("card.num", { num: 3 }) }}</th>
                  <th rowspan="2" class="txt">
                    <div>{{ $t("card.shuoming1") }}</div>
                    {{ $t("card.shuoming2") }}
                  </th>
                  <th rowspan="2" class="beizhu">
                    <div>
                      {{ $t("card.shuoming3") }}
                    </div>
                    {{ $t("card.shuoming4") }}
                  </th>
                </tr>
                <!-- 第三行 -->
                <tr class="tbody">
                  <th class="number">{{ $t("card.area", { area: 12 }) }}</th>
                  <th class="number">{{ $t("card.num", { num: 4 }) }}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--  表单结束 -->

      <div class="run">
        <p class="title">
          <span> {{ $t("card.contestant") }}</span>
          <!-- <span>
            <el-button @click="addNew()">{{
              $t("card.addContestant")
            }}</el-button></span
          > -->
        </p>

        <div class="runTab">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="{
              background: '#FDC400',
              color: '#333333',
              borderradius: '4px 4px 0px 0px',
            }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              :label="$t('card.name')"
              width="54"
              :selectable="checkSelectable"
            ></el-table-column>
            <el-table-column
              prop="name"
              :label="$t('card.name')"
              align="center"
              width="80"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.name.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.name)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="column11"
              :label="$t('card.cardType')"
              width="120"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.column11.includes('[')
                      ? '#FF190C'
                      : '#333',
                  }"
                  v-html="split(scope.row.column11)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="column12" :label="$t('card.idcard')">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.column12.includes('[')
                      ? '#FF190C'
                      : '#333',
                  }"
                  v-html="split(scope.row.column12)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              :label="$t('card.unitAddress')"
              width="180"
            >
            </el-table-column>
            <el-table-column prop="company" :label="$t('card.unitName')">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.company.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.company)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="boothNum"
              :label="$t('homepage.positionNumber')"
              align="center"
              width="120"
            >
            </el-table-column>

            <el-table-column prop="duty" :label="$t('card.duty')" width="110">
            </el-table-column>
            <el-table-column
              prop="phone"
              :label="$t('card.iphone')"
              width="180"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.phone.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.phone)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="email"
              :label="$t('card.email')"
              width="140"
              :rules="rules.email"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    color:
                      matchEmail(scope.row.email) === false
                        ? '#FF190C'
                        : '#333',
                  }"
                >
                  {{ scope.row.email }}
                </div>
                <!-- <span v-if="matchEmail(scope.row.email) === false" style="color: #FF190C">邮箱格式错误</span> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="auditFlag"
              :label="$t('card.state')"
              width="140"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.cause"
                  placement="top"
                  :disabled="!scope.row.cause"
                >
                  <span
                    :style="{
                      color: scope.row.auditFlag === '-1' ? '#FF190C' : '#333',
                    }"
                    >{{
                      scope.row.isSubmit === "1"
                        ? ""
                        : scope.row.auditFlag === "0"
                        ? $t("card.pass")
                        : scope.row.auditFlag === "-1"
                        ? $t("card.noPass")
                        : scope.row.auditFlag === "2"
                        ? $t("card.under")
                        : ""
                    }}</span
                  >
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.operate')" width="180">
              <template slot-scope="scope">
                <el-button type="text" class="edit" @click="openEdit(scope.row)"
                  ><i class="el-icon-edit-outline">{{
                    $t("common.edit")
                  }}</i></el-button
                >
                <el-button type="text" @click="deletMsg(scope.row.id)"
                  ><i class="el-icon-delete">{{
                    $t("common.delete")
                  }}</i></el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="download">
          <div class="item">
            <!-- <p>
              {{ $t("card.tishi1")
              }}<span class="template"
                ><a href="./apply.xlsx" download="展商证申请模板.xlsx">
                  {{ $t("card.tishi2") }}</a
                ></span
              >
            </p>
            <p>
              <el-upload
                class="upload-demo"
                :action="uploadExUrl"
                :headers="getToken()"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-success="handSuccess"
              >
                <el-button>{{ $t("card.uploadFile") }}</el-button>
              </el-upload>
            </p> -->
          </div>
          <div class="item sumit">
            <!-- <el-button type="primary" @click="submitVerify()">{{
              $t("common.submit")
            }}</el-button>
            <span>{{ $t("card.tishi3") }}</span> -->
          </div>
        </div>
      </div>
      <!-- 展品分类说明 -->
    </div>

    <!-- 编辑弹框开始 -->
    <div class="editMsg">
      <el-dialog
        :visible.sync="editVisible"
        width="30%"
        center
        :close-on-click-modal="false"
      >
        <span slot="title" class="dialog-footer">
          {{ $t("card.editContest") }}
        </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form
              :model="editContent"
              ref="editContent"
              label-width="150px"
              :rules="rules"
            >
              <el-form-item :label="$t('card.name') + '：'" prop="name">
                <el-input
                  v-model="editContent.name"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder')"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.unitName') + '：'" prop="company">
                <el-input
                  v-model="editContent.company"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder1')"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item
                :label="$t('card.unitAddress') + '：'"
                prop="address"
              >
                <el-input
                  v-model="editContent.address"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder8')"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.cardType') + '：'" prop="column11">
                <el-select
                  v-model="editContent.column11"
                  :placeholder="$t('card.placeholder2')"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input v-model="editContent.column11" autocomplete="off" placeholder="请输入证件类型" maxlength="100"></el-input> -->
              </el-form-item>

              <el-form-item :label="$t('card.IDnumber') + '：'" prop="column12">
                <el-input
                  v-model="editContent.column12"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder3')"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item
                :label="$t('homepage.positionNumber') + '：'"
                prop="boothNum"
              >
                <el-select
                  v-model="editContent.column13"
                  :placeholder="$t('card.placeholder4')"
                  style="width: 100%"
                  v-if="boothMore === true"
                >
                  <el-option
                    v-for="item in boothNumLists"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <span v-else>{{ editContent.boothNum }}</span>
              </el-form-item>

              <el-form-item :label="$t('card.duty') + '：'" prop="duty">
                <el-input
                  style="width: 100%"
                  v-model="editContent.duty"
                  :placeholder="$t('card.placeholder6')"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.iphone') + '：'" prop="phone">
                <el-input
                  v-model="editContent.phone"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder7')"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item label="E-mail：" prop="email">
                <el-input
                  type="age"
                  v-model="editContent.email"
                  autocomplete="off"
                  placeholder="请输入E-mail"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-row class="save"
                ><el-button @click="saveVerfiy()">{{
                  $t("common.save")
                }}</el-button></el-row
              >
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 编辑弹框结束 -->

    <!-- 新增弹框开始 -->
    <div class="editMsg">
      <el-dialog
        :visible.sync="saveVisible"
        width="30%"
        center
        :close-on-click-modal="false"
        @click="closeDialog"
        :destroy-on-close="true"
      >
        <span slot="title" class="dialog-footer">
          {{ $t("card.addContest") }}
        </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form
              :model="saveContent"
              ref="saveContent1"
              label-width="154px"
              :rules="rules"
            >
              <el-form-item :label="$t('card.name') + '：'" prop="name">
                <el-input
                  type="age"
                  v-model="saveContent.name"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder')"
                  maxlength="50"
                  show-word-limit
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.unitName') + '：'" prop="company">
                <el-input
                  type="age"
                  v-model="saveContent.company"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder1')"
                  maxlength="50"
                  show-word-limit
                  :validate-event="false"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('card.unitAddress') + '：'"
                prop="address"
              >
                <el-input
                  type="age"
                  v-model="saveContent.address"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder1')"
                  maxlength="50"
                  show-word-limit
                  :validate-event="false"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('card.cardType') + '：'" prop="column11">
                <!-- <el-input type="age" v-model="saveContent.documentType" autocomplete="off" placeholder="请输入证件类型" maxlength="100"></el-input> -->
                <el-select
                  v-model="saveContent.column11"
                  :placeholder="$t('card.placeholder2')"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('card.IDnumber') + '：'" prop="column12">
                <el-input
                  type="age"
                  v-model="saveContent.column12"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder3')"
                  maxlength="100"
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item
                :label="$t('homepage.positionNumber') + '：'"
                prop="boothNum"
              >
                <el-select
                  v-model="saveContent.column13"
                  :placeholder="$t('card.placeholder4')"
                  style="width: 100%"
                  v-if="boothMore === true"
                >
                  <el-option
                    v-for="item in boothNumLists"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                  type="age"
                  v-model="saveContent.boothNum"
                  value="1111"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder5')"
                  maxlength="100"
                  disabled
                  v-else
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.duty') + '：'" prop="duty">
                <el-input
                  style="width: 100%"
                  v-model="saveContent.duty"
                  :placeholder="$t('card.placeholder6')"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.iphone') + '：'" prop="phone">
                <el-input
                  type="age"
                  v-model="saveContent.phone"
                  autocomplete="off"
                  :placeholder="$t('card.placeholder7')"
                  maxlength="100"
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item label="E-mail：" prop="email">
                <el-input
                  type="age"
                  v-model="saveContent.email"
                  autocomplete="off"
                  placeholder="请输入E-mail"
                  maxlength="100"
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-row class="save"
                ><el-button
                  @click="sumitAdd('saveContent1')"
                  :loading="loadingFlage"
                  >{{ $t("common.save") }}</el-button
                ></el-row
              >
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 新增弹框结束 -->

    <!-- 提示信息 -->
    <div class="noticeMsg">
      <el-dialog
        :visible.sync="msgVisible"
        width="30%"
        center
        :close-on-click-modal="false"
      >
        <span slot="title" class="dialog-footer">{{ $t("card.tishi4") }}</span>
        <div class="content">
          {{ $t("card.tishi5") }}<span>{{ $t("card.tele") }}</span>
        </div>
        <el-row class="sure"
          ><el-button @click="msgVisible = false">{{
            $t("navbar.sure")
          }}</el-button></el-row
        >
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 提示信息结束 -->

    <!-- 提示信息 -->
    <div class="noticeMsg">
      <el-dialog
        :visible.sync="overflowVisible"
        width="30%"
        center
        :close-on-click-modal="false"
      >
        <span slot="title" class="dialog-footer">{{ $t("card.tishi6") }}</span>
        <div class="content">
          {{ $t("card.tishi7") }}<span>{{ $t("card.tele") }}</span>
        </div>
        <el-row class="sure"
          ><el-button @click="overflowVisible = false">{{
            $t("navbar.sure")
          }}</el-button></el-row
        >
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 提示信息结束 -->

    <div class="PassBox">
      <el-dialog :visible.sync="dialogVisiblePass" customClass="customWidth">
        <span slot="title" style="color: white" class="dialog-footer"
          >以下参展人员已被提交</span
        >
        <el-table :data="gridData">
          <el-table-column
            property="name"
            label="姓名"
            width="100"
          ></el-table-column>
          <el-table-column
            property="column12"
            label="身份证号"
          ></el-table-column>
        </el-table>
      </el-dialog>
    </div>


    <!-- 以下展位号不存在 -->
    <div class="noPassExnum">
      <el-dialog :visible.sync="dialognoPass" customClass="customWidth">
        <span slot="title" style="color: white" class="dialog-footer"
          >以下人员所填展位号不存在</span
        >
        <el-table :data="noPassexnum">
          <el-table-column
            property="name"
            label="姓名"
            width="100"
          ></el-table-column>
          <el-table-column
            property="boothNum"
            label="展位号"
          ></el-table-column>
        </el-table>
      </el-dialog>

    </div>

  </div>
</template>
<script>
import { getBooth } from "../../../../api/exhibitor.js";
import {
  getLists,
  addExhibitors,
  getItem,
  editItem,
  delItem,
  submitList,
} from "../../../../api/exhibitorBadge.js";
import { saveSeries } from "../../../../api/productCenter.js";
import { uploadExcelUrl } from "../../../../utils/common.js";
import { auth } from "../../../../api/common.js";
export default {
  data() {
    return {
      //重复人员标志窗口
      dialogVisiblePass: false,
      dialognoPass:false,//展位号不存在的标志
      gridData: [], //重复弹框下的数据
      noPassexnum:[],// 未通过展位
      loadingFlage: false,
      uploadExUrl: uploadExcelUrl(),
      boothMore: false,
      boothNumLists: [],
      // rules: {
      //   name: [{ required: true, message: "姓名不能为空" }],
      //   company: [{ required: true, message: "单位名称不能为空" }],
      //   address: [{ required: true, message: "单位地址不能为空" }],
      //   column11: [{ required: true, message: "证件类型不能为空" }],
      //   column12: [
      //     { required: true, message: "证件号码不能为空" },
      //     { validator: validateColumn12 },
      //   ],
      //   phone: [
      //     { required: true, message: "手机号码不能为空" },
      //     { validator: validatorPhone },
      //   ],
      //   // email: [{ validator: validatorEmail }],
      //   // boothNum: [{ required: true, message: '展位号不能为空' }],
      // },
      options: [
        {
          value: "身份证",
          label: this.$t("teamInvite.idcart"),
        },
        {
          value: "军官证",
          label: this.$t("teamInvite.certificate"),
        },
        {
          value: "护照",
          label: this.$t("teamInvite.passport"),
        },
        {
          value: "港澳通行证",
          label: this.$t("teamInvite.hk"),
        },
      ],
      // 判断当前参展人员的状态
      // flag: '',
      //文件上传下载
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],

      tableData: [],

      //编辑弹框标志位
      editVisible: false,
      //编辑弹框的具体内容
      editContent: {
        name: "", //姓名
        company: "", //单位名称
        address: "", //单位地址
        column11: "", //证件类型
        column12: "", //证件号
        column13: "", //展位id
        boothNum: "", //展位号
        duty: "", //职务
        phone: "", //手机号
        email: "", //邮箱
      },
      //保存弹框的具体内容
      saveVisible: false,
      //保存弹框的具体内容
      saveContent: {
        name: "", //姓名
        company: "", //单位名称
        address: "", //单位地址
        column11: "", //证件类型
        column12: "", //证件号
        column13: "", //展位id
        boothNum: "", //展位号
        duty: "", //职务
        phone: "", //手机号
        email: "", //邮箱
      },
      //登记窗口关闭提示信息
      msgVisible: false,
      //超出份额提示
      overflowVisible: false,
      editId: "",
      currentSelectLists: [],
    };
  },

  computed: {
    rules() {
      var validatorPhone = (rule, value, callback) => {
        const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (reg.test(value) === false) {
          callback(new Error(this.$t("card.rules.phoneLength")));
        }
        callback();
      };
      var validateColumn12 = (rule, value, callback) => {
        let type;
        if (this.editId) {
          type = this.editContent.column11;
        } else {
          type = this.saveContent.column11;
        }
        if (!type) {
          callback(new Error(this.$t("card.rules.placeholder")));
        }
        if (type === "身份证") {
          const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if (reg.test(value) === false) {
            callback(new Error(this.$t("card.rules.idcard")));
          }
        }
        // if (type === '军官证') {
        //   const reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;
        //   if (reg.test(value) === false) {
        //     callback(new Error('军官证号不合规，请重新输入'));
        //   }
        // }
        // if (type === '护照') {
        //   const reg = /^([a-zA-z]|[0-9]){5,17}$/;
        //   if (reg.test(value) === false) {
        //     callback(new Error('护照号码不合规，请重新输入'));
        //   }
        // }
        // if (type === '港澳通行证') {
        //   const reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
        //   if (reg.test(value) === false) {
        //     callback(new Error('港澳居民来往内地通行证号码不合规，请重新输入'));
        //   }
        // }
        callback();
      };
      return {
        name: [{ required: true, message: this.$t("card.rules.name") }],
        company: [{ required: true, message: this.$t("card.rules.company") }],
        // address: [{ required: true, message:  this.$t('card.rules.address') }],
        column11: [{ required: true, message: this.$t("card.rules.column11") }],
        column12: [
          { required: true, message: this.$t("card.rules.column12") },
          { validator: validateColumn12 },
        ],
        phone: [
          { required: true, message: this.$t("card.rules.phone") },
         
        ],
      };
    },
  },
  methods: {
    split(current) {
      if (current.includes("[")) {
        const arr = current.split("[");
        const result = arr[0] + "<br>" + arr[1].substr(0, arr[1].length - 1);
        return result;
      } else {
        return current;
      }
    },
    handleClosePass(done) {
      done();
    },

    matchEmail(email) {
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (reg.test(email) === false) {
        //邮箱不合格
        return false;
      } else {
        return true;
      }
    },
    getToken() {
      const a = localStorage.getItem("token");
      let token = {};
      token.token = a;
      return token;
    },
    handSuccess(file) {
      // 上传excel文件成功函数
      if (file.code == 200) {
        if(Number(file.data.status)==104){
          this.noPassexnum=file.data.notHasBootNum;
          this.dialognoPass=true;
        }else{
          this.dialognoPass=false
        }
        if (Number(file.data.status) == 103) {
          this.gridData = file.data.persons;
          this.dialogVisiblePass = true;
        } else {
          this.dialogVisiblePass = false;
        }

        // 文件上传成功
        if (file.data.status === "1" && file.data.tips === "超出分配数量") {
          this.overflowVisible = true;
        } else {
          this.$message({
            message: this.$t("dialog.message19"),
            type: "success",
          });
          this.getAllList();
        }
      }
    },
    handleSelectionChange(selection) {
      this.currentSelectLists = selection;
    },
    checkSelectable(row) {
      return row.auditFlag === "-1" || row.isSubmit === "1";
    },
    //提交参展人员审核函数
    async submitVerify() {
      const arr = [];
      this.currentSelectLists.map((item) => {
        arr.push(item.id);
      });
      try {
        const { data } = await submitList(arr);

        // console.log("提交返回的人员信息是：", data);
        if (data.code === 200) {
          if (Number(data.data.status) == 102) {
            this.$message({
              message: `${data.data.name}已被提交！`,
              type: "warning",
            });
            return false;
          }
          if (data.data.status === "1" && data.data.tips === "超出分配数量") {
            this.overflowVisible = true;
          }

          if (
            data.data.status === "2" &&
            data.data.tips === "请将红色提示修改后再提交"
          ) {
            this.$confirm(
              this.$t("dialog.message20"),
              this.$t("dialog.attention"),
              {
                confirmButtonText: this.$t("dialog.sure"),
                cancelButtonText: this.$t("dialog.cancel"),
                customClass: "myClass",
              }
            );
          }

          if (!data.data.tips) {
            this.$message({
              message: this.$t("dialog.message21"),
              type: "success",
            });

            this.getAllList();
          }
        }
      } catch (err) {}
    },
    //文件上传移除相关钩子函数
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //编辑弹框相关函数
    //打开编辑框
    async openEdit(row) {
      this.editVisible = true;
      this.editId = row.id;
      const params = { id: row.id };
      try {
        const { data } = await getItem(params);
        if (data.code === 200) {
          if (data.data.status === "1" && data.data.tips === "超出分配数量") {
            this.overflowVisible = true;
          }

          if (
            data.data.status === "2" &&
            data.data.tips === "参展人员登记窗口已关闭"
          ) {
            this.msgVisible = true;
          }
          if (!data.data.tips) {
            this.editContent = data.data;
            this.getBoothLists();
          }
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    //取消关闭编辑框
    closeEdit() {
      this.editVisible = false;
    },
    // 表单验证
    saveVerfiy() {
      // console.log("boothNumLists数据", this.boothNumLists);
      // console.log("编辑保存得数据",this.editContent);
      const number = this.boothNumLists.filter(
        (it) => it.value === this.editContent.column13
      );
      // console.log("删选之后出来得数组",number);
      if (this.boothNumLists.length > 0) {
        this.editContent.boothNum = number[0].label;
      }
      this.$refs.editContent.validate((valid) => {
        if (valid) {
          this.idAuth1(); //执行提交操作
        } else {
          return false;
        }
      });
    },

    async idAuth1() {
      // console.log("执行验证身份证");
      const params = {
        name: this.editContent.name,
        idCard: this.editContent.column12,
      };
      try {
        //  console.log("身份类型的值为",this.saveContent.column11);
        if (this.saveContent.column11 == "身份证") {
          const { data } = await auth(params);
          // console.log("身份证返回得信息",data);
          if (data.code === 200) {
            this.saveMsg();
          } else {
            // this.saveContent.column12 = "";
            this.loadingFlage = false;
            this.$message.error(this.$t("dialog.message22"));
          }
        } else {
          this.saveMsg();
        }
      } catch (err) {}
    },

    //编辑保存函数
    async saveMsg() {
      // console.log("编辑保存得数据",this.editContent);

      const params = this.editContent;
      params.id = this.editId;
      try {
        const { data } = await editItem(params);
        if (data.code === 200) {
          //增加提示信息
          if (Number(data.data.status) == 101) {
            this.$message({
              message: "该参展人员已被提交!",
              type: "warning",
            });
            return false;
          }

          this.editVisible = false;
          if (data.data.status === "1" && data.data.tips === "超出分配数量") {
            this.overflowVisible = true;
          }

          if (
            data.data.status === "2" &&
            data.data.tips === "参展人员登记窗口已关闭"
          ) {
            this.msgVisible = true;
          }
          if (data.data.tips === "成功" && data.data.status === "3") {
            this.$message({
              message: this.$t("dialog.message23"),
              type: "success",
            });
            this.getAllList();
          }
        }
      } catch (err) {
        this.$message.error(err);
      }
    },

    //表格数据删除
    async deletMsg(id) {
      const params = { id: id };
      this.$confirm(
        this.$t("dialog.confirmDelete"),
        this.$t("dialog.attention"),
        {
          confirmButtonText: this.$t("dialog.sure"),
          cancelButtonText: this.$t("dialog.cancel"),
          customClass: "myClass",
        }
      )
        .then(async () => {
          const { data } = await delItem(params);
          if (data.code === 200) {
            if (
              data.data.status === "2" &&
              data.data.tips === "参展人员登记窗口已关闭"
            ) {
              this.msgVisible = true;
            }
            if (!data.data.tips) {
              this.$message({
                message: this.$t("dialog.message24"),
                type: "success",
              });
              this.getAllList();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //打开新增弹框
    addNew() {
      // this.saveContent = { column11: "身份证" };

      this.saveContent.column11 = "身份证";
      this.saveVisible = true;
      setTimeout(() => {
        this.getBoothLists();
      }, 1000);
    },
    //保存操作
    async save1() {
      try {
        const { data } = await addExhibitors(this.saveContent);
        //console.log("新增的提示信息", data);
        if (data.code === 200) {
          //增加提示信息
          this.loadingFlage = false;
          if (Number(data.data.status) == 101) {
            this.$message({
              message: "该参展人员已被提交!",
              type: "warning",
            });
            return false;
          }

          this.saveVisible = false;

          if (data.data.status === "1" && data.data.tips === "超出分配数量") {
            this.overflowVisible = true;
          }

          if (
            data.data.status === "2" &&
            data.data.tips === "参展人员登记窗口已关闭"
          ) {
            this.msgVisible = true;
          }

          if (data.data.status === "3" && data.data.tips === "成功") {
           
           
            this.$message({
              message: this.$t("dialog.message25"),
              type: "success",
            });

            this.getAllList();
          }
        } else {
          this.$message({
            message: this.$t("dialog.message26"),
            type: "error",
          });
        }
      } catch (err) {
        this.$message.error("新增参展人员失败!");
      }
    },

    //保存
    sumitAdd(formName) {
      // console.log("boothNumLists数据", this.boothNumLists);

      if (this.boothNumLists.length > 1) {
        const number = this.boothNumLists.filter(
          (it) => it.value === this.saveContent.column13
        );
        // console.log("num的数据", number);

        this.saveContent.boothNum = number[0].label;
      } else {
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log("执行了添加");
          this.loadingFlage = true;
          this.idAuth(); //执行提交操作
        } else {
          return false;
        }
      });
    },

    // 身份认证函数
    async idAuth() {
      const params = {
        name: this.saveContent.name,
        idCard: this.saveContent.column12,
      };
      try {
        // console.log(this.saveContent.column11);
        if (this.saveContent.column11 == "身份证") {
          const { data } = await auth(params);
          // console.log("请求成功返回data",data);
          if (data.code === 200) {
            this.save1();
          } else {
            // this.saveContent.column12 = "";
            this.loadingFlage = false;
            this.$message.error(this.$t("dialog.message22"));
            // console.log("身份证不符合");
          }
        } else {
          this.save1();
        }
      } catch (err) {}
    },

    // 获取当前展商的展位
    async getBoothLists() {
      try {
        const { data } = await getBooth();
        const arr = data.data;
        if (data.code === 200) {
          if (arr.length > 1) {
            this.boothMore = true;
            this.boothNumLists = [];
            this.saveContent.column13 = arr[0].id;
            arr.map((item) => {
              this.boothNumLists.push({
                value: item.id,
                label: item.boothNum,
              });
            });
          } else {
            this.boothMore = false;
            this.saveContent.boothNum = arr[0].boothNum;
            this.saveContent.column13 = arr[0].id;
            // console.log("否则展商展位小于1", this.saveContent);
          }
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    async getAllList() {
      try {
        const { data } = await getLists();
        this.tableData = data.data;
      } catch (err) {
        this.$message.error(err);
      }
    },
    closeDialog() {
      this.$refs.saveContent.resetFields();
    },
  },
  created() {
    this.getAllList();
    this.getBoothLists();
  },
};
</script>

<style scoped lang="scss">
.apply {
  // padding: 17px 26px;
  box-sizing: border-box;
  background: #f0f2f5;
  .box-card {
    width: 100%;
    border-radius: 2px;
    background: #ffffff;
    .head {
      padding: 17px 0px;
      border-bottom: 1px solid #e8e8e8;
      .applyTitle {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 560;
        color: #333333;
        line-height: 24px;
        margin-left: 26px;
      }
      .applyEnd {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-left: 17px;
      }
    }
    //说明
    // .introduce {
    //   margin: 26px 17px 0px 17px;
    //   padding-bottom: 9px;
    //   background: #f6f6f7;
    //   .txt {
    //     padding-left: 65px;
    //     box-sizing: border-box;
    //     position: relative;
    //     padding-top: 9px;
    //     font-size: 14px;
    //     font-family: PingFangSC-Regular, PingFang SC;
    //     font-weight: 400;
    //     color: #333333;
    //     .shuoMing {
    //       position: absolute;
    //       top: 9px;
    //       left: 26px;
    //       font-size: 16px;
    //       font-family: PingFangSC-Regular, PingFang SC;
    //       font-weight: 400;
    //       color: #ff190c;
    //     }
    //     .telNumber {
    //       color: #006fb8;
    //     }
    //   }
    // }

    //说明
    .introduce {
      margin: 26px 17px 0px 17px;
      padding-bottom: 10px;
      background: #f6f6f7;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .box {
        flex: 1;
        padding-left: 10px;
        .txt {
          box-sizing: border-box;
          position: relative;
          padding-top: 9px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }

      .shuoMing {
        margin-left: 65px;
        padding-top: 7px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff190c;
      }
    }

    .instance {
      margin: 35px 17px 0px 17px;

      .distribution {
        .title {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          padding-bottom: 9px;
          border-bottom: 1px solid #e9e9e9;
        }
        .tab {
          margin-top: 9px;
          table {
            border-collapse: collapse;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            border-radius: 3px 3px 0px 0px;
            height: 36px;
            width: 100%;
            tbody {
              border: 1px solid #e8e8e8;
              .thead {
                height: 36px;
                background: #006fb8;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.85);
                line-height: 19px;
                .notice {
                  text-align: left;
                  padding-left: 45px;
                }
              }
              .tbody {
                .number {
                  border: 1px solid #e8e8e8;
                  height: 60px;
                  width: 120px;
                }
                .txt {
                  padding: 0px 85px;
                  box-sizing: border-box;
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                }
                .beizhu {
                  padding: 0px 45px;
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
    .run {
      margin: 35px 17px 0px 17px;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        padding-bottom: 9px;
        border-bottom: 1px solid #e9e9e9;
        display: flex;
        justify-content: space-between;
        .el-button {
          width: 100px;
          height: 28px;
          line-height: 0px;
          padding: 0px;
          position: relative;
          top: 3px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .runTab {
        margin-top: 10px;
      }
      .download {
        .item {
          margin-top: 17px;
          display: flex;
          justify-content: flex-start;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;

          p {
            line-height: 28px;
          }
          .upload-demo {
            margin-left: 52px;
          }
          .template {
            a {
              color: #006fb8;
            }
          }
        }
      }
    }
  }
  .editMsg {
    //编辑框的弹框信息
    .dialog-footer {
      width: 100%;
      position: relative;
      top: -5px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      //标题
      .instance {
        margin: 0px 17px 0px 17px;
        .title {
          padding: 35px 0px 9px 0px;
          border-bottom: 1px solid #e9e9e9;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
        .txt {
          margin-top: 17px;
          padding-left: 65px;
          box-sizing: border-box;
          position: relative;
          padding-top: 9px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          height: 36px;
          background: #f6f6f7;
          .shuoMing {
            position: absolute;
            top: 9px;
            left: 26px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff190c;
          }
        }
        .content {
          width: 50%;
          margin: 0 auto;
          margin-top: 35px;
          position: relative;
          left: -40px;
          .telNumber {
            color: #006fb8;
            margin-left: 5px;
          }
          .numberV {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 19px;
            letter-spacing: 1px;
            .remaining {
              color: #ff190c;
            }
          }
        }
        //展品信息分类
        .box {
          width: 60%;
          position: relative;
          left: 161px;
          //每一项开始
          .item {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .left {
              width: 107px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 19px;
              text-align: right;
              padding-right: 17px;
              padding-top: 10px;
              box-sizing: border-box;
            }
            .right {
              flex: 1;
              position: relative;
              .twoTitle {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .folding {
                position: absolute;
                right: 30px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
              }
            }
          }

          //每一项结束
        }
        .bottom {
          width: 60%;
          position: relative;
          left: 161px;
          .btn {
            margin-top: 22px;
            margin-bottom: 30px;
            .why {
              margin-left: 120px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ff190c;
              margin-bottom: 22px;
              a {
                margin-left: 10px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #006fb8;
              }
            }
          }
        }
      }
    }
  }

  .noticeMsg {
    //编辑框的弹框信息

    .dialog-footer {
      height: 36px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-align: left;
    }
    .content {
      border-bottom: 1px solid #00000017;
      padding-bottom: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      span {
        color: #006fb8;
        padding-left: 5px;
      }
    }
    .sure {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
    }
  }
}
</style>
<style scoped>
.el-table >>> th {
  padding: 0px !important;
  height: 36px;
}
.upload-demo >>> .el-button {
  width: 93px;
  height: 28px !important;
  padding: 0px;
}
.sumit >>> .el-button {
  margin-top: 10px;
  width: 76px;
  height: 28px;
  background: #006fb8;
  padding: 0px;
  margin-bottom: 163px;
}
.sumit span {
  height: 26px;
  line-height: 26px;
  padding: 10px;
  box-sizing: border-box;
  color: red;
}

[class*=" el-icon-"],
[class^="el-icon-"] {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #006fb8;
  line-height: 20px;
  margin: 0px 8px;
}
.edit {
  border-right: 1px solid #e9e9e9;
}

.runTab >>> .el-button {
  padding: 0px;
  border-radius: 0px;
}

.runTab >>> .el-button + .el-button {
  margin-left: 0px;
}
.el-dialog__wrapper >>> .el-dialog__header {
  background: #006fb8;
  display: flex;
  justify-content: space-between;
}
.save {
  overflow: hidden;

  position: relative;
  display: flex;
  justify-content: center;
}
.save >>> .el-button {
  padding: 0px;
  width: 30%;
  height: 35px;
  text-align: center;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.sure {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.sure >>> .el-button {
  padding: 0px;
  width: 65px;
  height: 32px;
  background: #006fb8;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.noticeMsg >>> .el-dialog__body {
  padding-bottom: 10px;
}
.apply >>> .el-dialog__close {
  color: #ffffff;
}

.dialog-footer {
  color: white;
}
</style>

<style scoped lang="scss">
.apply {
  position: relative;
}
.customWidth {
  width: 24%;
}
</style>
